module.exports = __webpack_public_path__ + "static/img/organism-h5.a528130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5.png
// module id = bKMH
// module chunks = 34